import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import BackIcon from "../../assets/images/Back Button.svg";
import AtkLoader from "../../AtlaskitControls/AtkLoader";
import CommonValues from "../../common/utils";
import axios from "axios";
import AtkTextField from "../../AtlaskitControls/AtkTextField";
import AtkButtonIconBefore from "../../AtlaskitControls/AtkButtonIconBefore";
import { Toast } from "primereact/toast";
import moment from "moment";
import SectionMessage from "@atlaskit/section-message"
import { RadioButton } from "primereact/radiobutton";
import { Dropdown } from "primereact/dropdown";
import { Dialog } from "primereact/dialog";
import AtkButton from "../../AtlaskitControls/AtkButton";
import AtkMessage from "../../AtlaskitControls/AtkMessage";
import { getMatches, isValid } from 'driver-license-validator';
import ImageIcon from "../../assets/images/ImageIcon.png";
import PlusSign from "../../assets/images/PlusSing1.webp";
import PfdIcon from "../../assets/images/file.png";
import PreviewIcon from "../../assets/images/paper.png";
import RemoveIcon from "../../assets/images/trashcan.png";

export default function MVRLandingPage(props: any) {
  const navigate = useNavigate();
  const location = useLocation();
  const toast: any = useRef("");
  const hostname = window.location.hostname;
  const [currentBalanceLoading, setCurrentBalanceLoading] = useState(false);
  const [currentBalance, setCurrentBalance] = useState("0");
  const [searchStartDate, setSearchStartDate] = useState('');
  const [licenseState, setLicenseState] = useState('');
  const [licenseNumber, setLicenseNumber] = useState('');
  const [birthDate, setBirthDate] = useState('');
  const [firstName, setFirstName] = useState('');
  const [middleName, setMiddleName] = useState('');
  const [lastName, setLastName] = useState('');
  const [address, setAddress] = useState('');
  const [city, setCity] = useState('');
  const [state, setState] = useState('');
  const [zipcode, setZipcode] = useState("");
  const [firstNameError, setFirstNameError] = useState("");
  const [lastNameError, setLastNameError] = useState("");
  const [licenseStateError, setLicenseStateError] = useState("");
  const [licenseNumberError, setLicenseNumberError] = useState("");
  const [birthDateError, setBirthDateError] = useState("");
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [onSubmitLoading, setOnSubmitLoading] = useState(false);
  const [selectedText, setSelectedText] = useState("ActivityHistory");
  const [selectionOptionDisabled, setSelectionOptionDisabled] = useState(false);
  const [apiCost, setApiCost] = useState<number>(0);
  const [stateFee, setStateFee] = useState<number>(0);
  const [showBalanceCutDialogBox, setShowBalanceCutDialogBox] = useState(false)
  const [selectedSubType, setSelectedSubType] = useState("");
  const [selectYearErrorMessage, setSelectYearErrorMessage] = useState("");
  const [showRateLimitMessage, setShowRateLimitMessage] = useState(false);
  const [showDrivingLicenseScanDialog, setShowDrivingLicenseScanDialog] = useState(false);
  const [fileNameTitle, setFileNameTitle] = useState("");
  const [fileName, setFileName] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [uploadFileLimit, setUploadFileLimit] = useState(1);
  const [uploadFile, setUploadFile] = useState<any>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (hostname !== process.env.REACT_APP_Momentum_Url1 && hostname !== process.env.REACT_APP_Momentum_Url2 && hostname !== process.env.REACT_APP_Momentum_Url3 && hostname !== process.env.REACT_APP_Momentum_Url4) {
      navigate("/not-allowed");
    }
  }, [hostname, navigate]);

  const getCurrentBalance = () => {
    setCurrentBalanceLoading(true);
    var token = CommonValues.GetToken();
    var config = {
      method: "get",
      url: `${process.env.REACT_APP_STRIPEPAYMENTGATEWAY}/api/billing/current-balance`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    axios(config)
      .then((response) => {
        if (response.data.success == true) {
          setCurrentBalance((response.data.currentBalance / 100).toFixed(2));
        }
        setCurrentBalanceLoading(false);
      })
      .catch((error) => {
        setCurrentBalanceLoading(false);
        if (error.response != null) {
          if (error.response.status == 401) {
            CommonValues.Logout(navigate);
          } else {
            toast.current.show({
              severity: "error", summary: 'Error',
              detail: "Unknown error while getting current balance",
              life: 3000,
            });
          }
        } else {
          toast.current.show({
            severity: "error", summary: 'Error',
            detail: "Unknown error while getting current balance",
            life: 3000,
          });
        }
      });
  };

  useEffect(() => {
    let state: any = "";
    let licenseState: any = "";
    if (props.driverDetails.state == "" || props.driverDetails.state == null || props.driverDetails.state == undefined) {
      setState(state);
    } else {
      state = Allstate.find((State) => State.value === props.driverDetails.state) || Allstate.find((State) => State.label === props.driverDetails.state);
      if(state == undefined) {
        setState("");
      }else{
      setState(state.value);
      }
      
    }
    if (props.driverDetails.licenseState == "" || props.driverDetails.licenseState == null || props.driverDetails.licenseState == undefined) {
      setLicenseState("")
    } else {
      licenseState = Allstate.find((State) => State.value === props.driverDetails.licenseState) || Allstate.find((State) => State.label === props.driverDetails.licenseState);
      if(licenseState == undefined) {
        setLicenseState("");
      }else{
       setLicenseState(licenseState.value)
      }
    }
    getCurrentBalance();
    setFirstName(props.driverDetails.firstName);
    setMiddleName(props.driverDetails.middleName);
    setLastName(props.driverDetails.lastName);
    setBirthDate(props.driverDetails.dateOfBirth == "" ? "" : moment(props.driverDetails.dateOfBirth).format("YYYY-MM-DD"));
    setLicenseNumber((props.driverDetails.licenseNumber || "").replace(/\s/g, "").replace(/-/g, ""));
    setAddress(props.driverDetails.addressLine1);
    setCity(props.driverDetails.city);
    setZipcode(props.driverDetails.zipCode);
    setSearchStartDate(moment().subtract(3, 'years').format("YYYY-MM-DD"));
  }, []);


  const Allstate = [
    { label: "Select state", value: "" },
    { label: "Alaska", value: "AK" },
    { label: "Alabama", value: "AL" },
    { label: "Arkansas", value: "AR" },
    { label: "Arizona", value: "AZ" },
    { label: "California", value: "CA" },
    { label: "Colorado", value: "CO" },
    { label: "Connecticut", value: "CT" },
    { label: "District of Columbia", value: "DC" },
    { label: "Delaware", value: "DE" },
    { label: "Florida", value: "FL" },
    { label: "Georgia", value: "GA" },
    { label: "Hawaii", value: "HI" },
    { label: "Iowa", value: "IA" },
    { label: "Idaho", value: "ID" },
    { label: "Illinois", value: "IL" },
    { label: "Indiana", value: "IN" },
    { label: "Kansas", value: "KS" },
    { label: "Kentucky", value: "KY" },
    { label: "Louisiana", value: "LA" },
    { label: "Massachusetts", value: "MA" },
    { label: "Maryland", value: "MD" },
    { label: "Maine", value: "ME" },
    { label: "Michigan", value: "MI" },
    { label: "Minnesota", value: "MN" },
    { label: "Missouri", value: "MO" },
    { label: "Mississippi", value: "MS" },
    { label: "Montana", value: "MT" },
    { label: "North Carolina", value: "NC" },
    { label: "North Dakota", value: "ND" },
    { label: "Nebraska", value: "NE" },
    { label: "New Hampshire", value: "NH" },
    { label: "New Jersey", value: "NJ" },
    { label: "New Mexico", value: "NM" },
    { label: "Nevada", value: "NV" },
    { label: "New York", value: "NY" },
    { label: "Ohio", value: "OH" },
    { label: "Oklahoma", value: "OK" },
    { label: "Oregon", value: "OR" },
    { label: "Pennsylvania", value: "PA" },
    { label: "Rhode Island", value: "RI" },
    { label: "South Carolina", value: "SC" },
    { label: "South Dakota", value: "SD" },
    { label: "Tennessee", value: "TN" },
    { label: "Texas", value: "TX" },
    { label: "Utah", value: "UT" },
    { label: "Virginia", value: "VA" },
    { label: "Vermont", value: "VT" },
    { label: "Washington", value: "WA" },
    { label: "Wisconsin", value: "WI" },
    { label: "West Virginia", value: "WV" },
    { label: "Wyoming", value: "WY" },
  ];

  const fessList = [
    { "state": "Alabama", "record_type": "3Y", "cost": 10.00 },
    { "state": "Alaska", "record_type": "3Y", "cost": 10.00 },
    { "state": "Arizona", "record_type": "5Y (instant)", "cost": 8.00 },
    { "state": "Arizona", "record_type": "3Y (instant)", "cost": 6.00 },
    { "state": "Arizona", "record_type": "3Y (overnight)", "cost": 5.00 },
    { "state": "Arkansas", "record_type": "EM (commercial)", "cost": 14.20, "effective_date": "08/01/2024" },
    { "state": "Arkansas", "record_type": "3Y (standard)", "cost": 12.70, "effective_date": "08/01/2024" },
    { "state": "California", "record_type": "3Y", "cost": 2.00 },
    { "state": "California", "record_type": "EPN Enrollment", "cost": 5.00 },
    { "state": "Colorado", "record_type": "7Y", "cost": 6.00, "effective_date": "01/01/2024" },
    { "state": "Connecticut", "record_type": "3Y", "cost": 18.00 },
    { "state": "Delaware", "record_type": "3Y", "cost": 25.00 },
    { "state": "District of Columbia", "record_type": "3Y", "cost": 13.00 },
    { "state": "Florida", "record_type": "7Y (commercial)", "cost": 10.02 },
    { "state": "Florida", "record_type": "3Y", "cost": 8.02 },
    { "state": "Georgia", "record_type": "7Y", "cost": 8.00 },
    { "state": "Georgia", "record_type": "3Y", "cost": 6.00 },
    { "state": "Hawaii", "record_type": "3Y (overnight)", "cost": 23.00 },
    { "state": "Idaho", "record_type": "3Y", "cost": 10.00, "effective_date": "07/01/2023" },
    { "state": "Illinois", "record_type": "3Y", "cost": 20.00, "effective_date": "07/01/2023" },
    { "state": "Indiana", "record_type": "3Y", "cost": 10.00, "effective_date": "12/01/2021" },
    { "state": "Iowa", "record_type": "3Y", "cost": 10.30, "effective_date": "02/01/2020" },
    { "state": "Kansas", "record_type": "3Y", "cost": 16.70, "effective_date": "11/01/2020" },
    { "state": "Kentucky", "record_type": "3Y", "cost": 6.00, "effective_date": "01/01/2023" },
    { "state": "Louisiana", "record_type": "EM", "cost": 18.00 },
    { "state": "Louisiana", "record_type": "3Y", "cost": 18.00 },
    { "state": "Maine", "record_type": "7Y", "cost": 12.00 },
    { "state": "Maine", "record_type": "3Y", "cost": 7.00 },
    { "state": "Maryland", "record_type": "3Y", "cost": 15.00, "effective_date": "09/01/2024" },
    { "state": "Massachusetts", "record_type": "3Y", "cost": 8.00 },
    { "state": "Michigan", "record_type": "EM", "cost": 15.00 },
    { "state": "Michigan", "record_type": "3Y", "cost": 15.00 },
    { "state": "Minnesota", "record_type": "7Y", "cost": 5.00, "effective_date": "10/01/2023" },
    { "state": "Minnesota", "record_type": "3Y", "cost": 5.00 },
    { "state": "Mississippi", "record_type": "3Y", "cost": 14.00 },
    { "state": "Missouri", "record_type": "DB", "cost": 5.80 },
    { "state": "Missouri", "record_type": "3Y (overnight)", "cost": 0.12 },
    { "state": "Montana", "record_type": "3Y", "cost": 7.87, "effective_date": "10/01/2020" },
    { "state": "Nebraska", "record_type": "3Y", "cost": 7.50, "effective_date": "07/01/2021" },
    { "state": "Nevada", "record_type": "3Y", "cost": 7.00 },
    { "state": "New Hampshire", "record_type": "3Y", "cost": 17.00, "effective_date": "07/01/2023" },
    { "state": "New Jersey", "record_type": "5Y", "cost": 12.00 },
    { "state": "New Mexico", "record_type": "3Y", "cost": 6.50 },
    { "state": "New York", "record_type": "3Y", "cost": 7.00 },
    { "state": "North Carolina", "record_type": "7Y", "cost": 12.75, "effective_date": "07/01/2024" },
    { "state": "North Carolina", "record_type": "3Y", "cost": 12.75, "effective_date": "07/01/2024" },
    { "state": "North Dakota", "record_type": "3Y", "cost": 3.00 },
    { "state": "Ohio", "record_type": "3Y", "cost": 5.00 },
    { "state": "Oklahoma", "record_type": "3Y", "cost": 27.50 },
    { "state": "Oregon", "record_type": "EM", "cost": 13.99, "effective_date": "07/01/2023" },
    { "state": "Oregon", "record_type": "3Y", "cost": 13.99, "effective_date": "07/01/2023" },
    { "state": "Oregon", "record_type": "CR", "cost": 13.99, "effective_date": "07/01/2023" },
    { "state": "Pennsylvania", "record_type": "EM", "cost": 16.00, "effective_date": "07/01/2023" },
    { "state": "Pennsylvania", "record_type": "3Y", "cost": 16.00, "effective_date": "07/01/2023" },
    { "state": "Rhode Island", "record_type": "3Y", "cost": 21.00, "effective_date": "07/01/2020" },
    { "state": "South Carolina", "record_type": "7Y", "cost": 7.25 },
    { "state": "South Dakota", "record_type": "3Y", "cost": 5.00 },
    { "state": "Tennessee", "record_type": "3Y", "cost": 7.50 },
    { "state": "Texas", "record_type": "EM (commercial)", "cost": 7.50 },
    { "state": "Texas", "record_type": "3Y", "cost": 6.50 },
    { "state": "Utah", "record_type": "EM (commercial)", "cost": 11.00, "effective_date": "07/01/2018" },
    { "state": "Utah", "record_type": "3Y", "cost": 11.00 },
    { "state": "Vermont", "record_type": "3Y", "cost": 21.00, "effective_date": "01/01/2024" },
    { "state": "Virginia", "record_type": "3Y", "cost": 8.00 },
    { "state": "Washington", "record_type": "5Y", "cost": 15.00, "effective_date": "10/01/2022" },
    { "state": "West Virginia", "record_type": "3Y", "cost": 12.50 },
    { "state": "Wisconsin", "record_type": "5Y", "cost": 7.00 },
    { "state": "Wyoming", "record_type": "EM", "cost": 10.00, "effective_date": "02/01/2024" },
    { "state": "Wyoming", "record_type": "3Y", "cost": 10.00, "effective_date": "02/01/2024" }
  ]

  const onChangeSearchStartDate = (value: any) => {
    setSearchStartDate(value);
    setLicenseNumberError("");
  };

  const licenseStateDropdownClicked = (e: any) => {
    if (e.target.value.label == "Select state") {
      setLicenseState("");
      setLicenseStateError("")
    } else {
      setLicenseState(e.target.value);
      setLicenseStateError("");
      setSelectedSubType("")
    }

  };

  const onChangeLicenseNumber = (value: any) => {
    if (value.length <= 20) {
      setLicenseNumber(value);
      setLicenseNumberError("");
    }
  };

  const onChangeBirthDate = (value: any) => {
    setBirthDate(value);
    setBirthDateError("");
  };

  const onChangeFirstName = (value: any) => {
    let inputValue = value.replace(/[^a-zA-Z ]/g, "");
    if (inputValue.length <= 50) {
      setFirstName(inputValue);
      setFirstNameError("");
    }
  };

  const onChangeMiddleName = (value: any) => {
    let inputValue = value.replace(/[^a-zA-Z ]/g, "");
    if (inputValue.length <= 50) {
      setMiddleName(value);
    }

  };

  const onChangeLastName = (value: any) => {
    let inputValue = value.replace(/[^a-zA-Z ]/g, "");
    if (inputValue.length <= 50) {
      setLastName(value);
      setLastNameError("");
    }
  };

  const onChangeAddress = (value: any) => {
    let inputValue = value.replace(/[^a-zA-Z0-9 ]/g, "");
    const Value = inputValue.slice(0, 100);
    setAddress(Value);
  };

  const onChangeCity = (value: any) => {
    let inputValue = value.replace(/[^a-zA-Z ]/g, "");
    setCity(inputValue.slice(0, 50));
  };

  const stateDropdownClicked = (e: any) => {
    setState(e.value);
  };

  const yearDropDownClick = (e: any) => {
    setSelectYearErrorMessage("")
    if (e.target.value.label == "Select year") {
      setSelectedSubType("");
    } else {
      setSelectedSubType(e.target.value);
    }
  }

  const onChangeZipcode = (value: any) => {
    const numericValue = value.replace(/\D/g, "");
    if (numericValue.length <= 9) {
      setZipcode(numericValue);
    }
  };

  const onSubmitClick = () => {
    if (checkValidation()) {
      setShowBalanceCutDialogBox(true);
    }
  }

  const placeOrder = () => {
    setOnSubmitLoading(true);
    let addressDetails = {
      street: address,
      city: city,
      state: state,
      zipcode: parseInt((zipcode || "").replace("-", ""), 10) || 0,
    }
    let mvrRequest = {
      searchStartDate: searchStartDate,
      licenseState: licenseState,
      licenseNumber: licenseNumber,
      birthDate: moment(birthDate).format("YYYY-MM-DD"),
      firstName: firstName,
      middleName: middleName,
      lastName: lastName,
      address: addressDetails,
      billCode: "Demo",
      billReference: "Account"
    }

    let selectionOptionJson = JSON.stringify({
      clientName: props.clientName,
      selectedDriverDetails: props.driverDetails
    })
    var data = JSON.stringify({
      apiCost: 400,
      apiType: selectedText,
      selectionOptionJson: selectionOptionJson,
      mvrRequest: mvrRequest
    })

    const token = CommonValues.GetToken();
    var config = {
      method: "post",
      url: `${process.env.REACT_APP_DataFabric_Url}/api/mvr/placeorder`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      },
      data: data,
    };

    axios(config)
      .then((response: any) => {
        if (response.data.message == null) {
          getCurrentBalance()
          setShowSuccessMessage(true);
          setSelectionOptionDisabled(true);
        }
        else {
          toast.current.show({ severity: "warn", summary: 'Warning', detail: response.data.message, life: 3000 });
        }
        setOnSubmitLoading(false);

      })
      .catch((error: any) => {
        if (error.response != null) {
          if (error.response.status === 401) {
            CommonValues.Logout(navigate);
          } else if (error.response.status === 429) {
            setShowRateLimitMessage(true)
            setShowBalanceCutDialogBox(false)
          } else {
            toast.current.show({ severity: "error", summary: 'Error', detail: "Unknown error while order place.", life: 3000 });
          }
        }
        setOnSubmitLoading(false);
      });
  }

  const mVRPlaceOrder = () => {
    let subTypeAndHostValue = selectedSubType.split(" ")
    setOnSubmitLoading(true);
    let addressDetails = {
      street: address,
      city: city,
      state: state,
      zipcode: parseInt((zipcode || "").replace("-", ""), 10) || 0,
    }
    var mvrRequest = {
      searchStartDate:searchStartDate,
      licenseState: licenseState,
      licenseNumber: licenseNumber,
      birthDate: moment(birthDate).format("YYYY-MM-DD"),
      firstName: firstName,
      middleName: middleName,
      lastName: lastName,
      address: addressDetails,
      productId: "DL",
      subType: subTypeAndHostValue[0],
      host: "ONLINE",
      purpose: "EMPLOYMENT",
      billCode: "Demo",
      billReference: "Account"
    }
    let selectionOptionJson = JSON.stringify({
      clientName: props.clientName,
      selectedDriverDetails: props.driverDetails
    })
    var data = JSON.stringify({
      apiCost: apiCost * 100, // Convert dollar to cent
      apiType: selectedText,
      selectionOptionJson: selectionOptionJson,
      transactionalMVRRequestModel: mvrRequest
    })
    const token = CommonValues.GetToken();
    var config = {
      method: "post",
      url: `${process.env.REACT_APP_DataFabric_Url}/api/mvr/mvrorder`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      },
      data: data,
    };

    axios(config)
      .then((response: any) => {
        if (response.data.message == null) {
          getCurrentBalance()
          setShowSuccessMessage(true);
          setSelectionOptionDisabled(true);
        } else {
          toast.current.show({ severity: "warn", summary: 'Warning', detail: response.data.message, life: 3000 });
        }
        setOnSubmitLoading(false);
      })
      .catch((error: any) => {
        if (error.response != null) {
          if (error.response.status === 401) {
            CommonValues.Logout(navigate);
          } else if (error.response.status === 429) {
            setShowRateLimitMessage(true)
            setShowBalanceCutDialogBox(false)
          } else {
            toast.current.show({ severity: "error", summary: 'Error', detail: "Unknown error while mvr order place.", life: 3000 });
          }
        }
        setOnSubmitLoading(false);
      });
  }

  const onHistoryClick = () => {
    navigate("/mvrhistory");
  }

  const checkValidation = () => {
    let iSValid = true;
    if (firstName == "" || firstName == null) {
      iSValid = false;
      setFirstNameError("Please enter first name.");
    }

    if (lastName == "" || lastName == null) {
      iSValid = false;
      setLastNameError("Please enter last name.");
    }

    if (licenseState == "" || licenseState == null) {
      iSValid = false;
      setLicenseStateError("Please select license state.");
    }

    if (selectedText == "TransactionalMVR") {

      if (selectedSubType == "" || selectedSubType == null) {
        iSValid = false;
        setSelectYearErrorMessage("Please select year.");
      }
    }
    if (licenseNumber == "" || licenseNumber == null) {
      iSValid = false;
      setLicenseNumberError("Please enter license number.");
    } else {
      let state = Allstate.find((State) => State.value === licenseState) || Allstate.find((State) => State.label === licenseState);
      if (state && state.value && !isValid(licenseNumber, { states: state.value })) {
        iSValid = false;
        setLicenseNumberError("Please enter valid license number.");
      }
    }

    if (birthDate == "" || birthDate == null || birthDate == "Invalid date") {
      iSValid = false;
      setBirthDateError("Please enter birth date.");
    } else {
      const yearsAgo = moment().subtract(16, 'years');
      if (moment(birthDate).isAfter(moment()) || moment(birthDate).isAfter(yearsAgo)) {
        iSValid = false;
        setBirthDateError("Birth date must be at least 16 years earlier than today.");
      }
    }
    return iSValid
  }

  const onChangeActivityHistory = (e: any) => {
    setSelectedText(e.value)
  }

  const onHidePopupClicked = () => {
    setShowBalanceCutDialogBox(false);
  };

  const onHideRateLimitPopupClicked = () => {
    setShowRateLimitMessage(false);
  };

  const onOkClick = () => {
    setShowBalanceCutDialogBox(false);
    if (selectedText == "ActivityHistory") {
      placeOrder();
    } else {
      mVRPlaceOrder();
    }
  }

  const onScanDocumentClicked = () => {
    setShowDrivingLicenseScanDialog(true);
  }

  const onHideDrivingLicenseScanDialogClicked = () => {
    setShowDrivingLicenseScanDialog(false);
    setFileName("");
    setFileNameTitle("");
    setUploadFile([]);
  }

  const onDropHandler = (event: any) => {
    event.preventDefault();
    onFileSelectHandler(event.dataTransfer.files);
  };

  const onFileSelectHandler = (files: any) => {
    setFileName("");
    setFileNameTitle("");
    const isValidated = validateSelectedFiles(files);
    if (!isValidated) {
      setErrorMessage("Please select PDF,JPEG,PNG,JPG files only");
      setTimeout(() => {
        setErrorMessage("");
      }, 3000);
      return false;
    }

    let fileList = [];
    let totalSize = 0;
    let currentFiles = uploadFile;
    let filename = files[0].name;
    if (filename.length > 50) {
      let shortenString = filename.substring(0, 50).concat("...");
      setFileName(filename);
      setFileNameTitle(shortenString);
    } else {
      setFileName(filename);
      setFileNameTitle(filename);
    }
    for (let i = 0, len = files.length; i < len; i++) {
      fileList.push({
        file: files[i],
        name: files[i].name,
        size: files[i].size,
      });
      totalSize = totalSize + files[i].size;
    }

    if (fileList.length > 0) {
      if (currentFiles.length > 0) {
        for (var i = 0, l = currentFiles.length; i < l; i++) {
          for (var j = 0; j < fileList.length; j++) {
            if (currentFiles[i].name === fileList[j].name) {
              fileList.splice(j, 1);
            }
          }
        }
      }
      let allFiles = currentFiles.concat(fileList);
      if (allFiles.length > uploadFileLimit) {
        allFiles = allFiles.slice(0, uploadFileLimit);
        setErrorMessage(
          "Multiple files cannot be uploaded at the same time; please upload a single file"
        );
        setTimeout(() => {
          setErrorMessage("");
        }, 3000);
      }
      setUploadFile(allFiles);
    }
  };

  const validateSelectedFiles = (files: any) => {
    var regularExpression = /(?:\.([^.]+))?$/;
    var isValid = true;

    for (let index = 0, len = files.length; index < len; index++) {
      const fileExtension: any = regularExpression.exec(files[index].name);
      if (fileExtension === undefined || fileExtension[0] == "") {
        isValid = false;
        break;
      }
      if (
        fileExtension?.[1].toLowerCase().includes("pdf") ||
        fileExtension?.[1].toLowerCase().includes("jpg") ||
        fileExtension?.[1].toLowerCase().includes("jpeg") ||
        fileExtension?.[1].toLowerCase().includes("png")
      ) {
        isValid = true;
      } else {
        isValid = false;
        break;
      }
    }
    return isValid;
  };

  const removeFileFromList = () => {
    setUploadFile([]);
  };

  const createUploadRequest = () => {
    setLoading(true);
    var FormData = require("form-data");
    var data = new FormData();
    data.append("drivingLicense", uploadFile[0].file);
    const selectionOptionsJson = {
      useExistingInsured: false,
      insuredClientId: "",
      clientName: props.clientName,
    };
    data.append("selectedOption", JSON.stringify(selectionOptionsJson));
    let token = CommonValues.GetToken();

    var config = {
      method: "post",
      url: `${process.env.REACT_APP_PolicyAgent_Url}/scan_driving_license`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: data,
    };
    axios(config)
      .then((response: any) => {
        setLoading(false);
        if (response.data.success) {
          const drivingLicenseResponse = JSON.parse(
            response.data.drivingLicenseResponse
          );
          setFirstName(drivingLicenseResponse.firstName);
          setLastName(drivingLicenseResponse.lastName);
          setBirthDate(drivingLicenseResponse.dateOfBirth);
          setLicenseNumber(drivingLicenseResponse.drivingLicenseNumber.replace(/\s/g, "").replace(/-/g, ""));
          setAddress(drivingLicenseResponse.addressLine1);
          setCity(drivingLicenseResponse.city);
          setState(drivingLicenseResponse.state);
          setZipcode(drivingLicenseResponse.zipCode);
          setLicenseState(drivingLicenseResponse.state);
          setShowDrivingLicenseScanDialog(false);
          getCurrentBalance();
          setFileName("");
          setFileNameTitle("");
          setUploadFile([])
          setFirstNameError("");
          setLastNameError("");
          setLicenseStateError("");
          setLicenseNumberError("");
          setBirthDateError("");
          setSelectYearErrorMessage("");
        } else {
          toast.current.show({
            severity: "info",
            summary: "Info",
            detail: response.data.errorMessage,
            life: 3000,
          });
        }
      })
      .catch((error: any) => {
        if (error.response != null && error.response.status == 401) {
          navigate("/");
          CommonValues.Logout(navigate);
        } else {
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: "Error while creating the request.",
            life: 3000,
          });
          setLoading(false);
        }
      });
  };

  return (
    <>
      <div className="col-12  p-0">
        <Toast ref={toast} />
        <div className="row d-flex justify-content-end scan-search-row mx-auto ">
          {" "}
          <div className="col-6 d-flex align-items-center">
            <span>
              {" "}
              <img src={BackIcon} className="show-cursor me-3" height={20} width={20} title="Back" onClick={props.onBackButtonClick} />
            </span>
            <span className=" me-3">
              <label>
                <b>Client Name: </b> &nbsp;
              </label>
              {props.clientName}
            </span>

            <div className="align-items-center">
              <RadioButton
                inputId="activityHistory"
                name="mvrType"
                value="ActivityHistory"
                onChange={(e) => onChangeActivityHistory(e)}
                checked={selectedText === "ActivityHistory"}
                disabled={selectionOptionDisabled == true ? true : false}
              />
              <label htmlFor="activityHistory" className="mx-2">
                <b>Activity History</b>
              </label>

              <RadioButton
                inputId="transactionalMVR"
                name="transactionalType"
                value="TransactionalMVR"
                onChange={(e) => setSelectedText(e.value)}
                checked={selectedText === "TransactionalMVR"}
                disabled={selectionOptionDisabled == true ? true : false}
              />
              <label htmlFor="transactionalMVR" className="mx-2">
                <b>Transactional MVR</b>
              </label>
            </div>
            {props.isUsingNewInformation == true ?
              <div className="ms-3">
                <AtkButton
                  label="Scan Driving License"
                  className="pf-primary-btn"
                  onClick={onScanDocumentClicked}
                />
              </div>
              : null}
          </div>
          <div className="col-6 d-flex justify-content-end ">
            <div className="balance-span">
              <label>Current Balance</label>
              {currentBalanceLoading ? (
                <span className="balance-spinner d-flex  align-items-center justify-content-center ">
                  <AtkLoader />
                </span>
              ) : (
                <span className=" d-block w-auto ">${currentBalance}</span>
              )}
            </div>
          </div>

          <Dialog
            visible={showRateLimitMessage}
            onHide={onHideRateLimitPopupClicked}
            draggable={false}
            className="mvr-confirmation-dialogBox"
          >
            <AtkMessage appearance="information" messageText={"Please wait 20 seconds before submitting another mvr request."} />
          </Dialog>

          <Dialog
            header={
              <div className="d-flex justify-content-between align-items-center w-100">
                <span className="text-16">Confirmation</span>
              </div>
            }
            visible={showBalanceCutDialogBox}
            onHide={onHidePopupClicked}
            draggable={false}
            className="mvr-confirmation-dialogBox"
          >
            <div className="mvr-confirmation-box mt-3">
              {selectedText == "ActivityHistory" ?
                <div style={{
                  backgroundColor: '#eef4ff',
                  padding: '10px',
                  borderRadius: '5px',
                  marginBottom: '20px',
                  textAlign: 'center'
                }}>

                  Your account will be charged a total of <b>$4</b> for this MVR record. Do you wish to proceed?
                </div>
                :
                <>
                  <div style={{
                    backgroundColor: '#eef4ff',
                    padding: '10px',
                    borderRadius: '5px',
                    marginBottom: '20px',
                    textAlign: 'center'
                  }}>

                    Your account will be charged a total of <b>${apiCost}</b> for this MVR record. Do you wish to proceed?
                  </div>
                </>}
              <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', marginBottom: '10px' }}>
                {selectedText == "ActivityHistory" ?
                  <>
                    <span>Service Fee:</span>
                    <span>${"4.00"}</span>
                  </> :
                  <>
                    <span>Service Fee:</span>
                    <span>${"3.00"}</span>
                  </>}
              </div>

              <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', marginBottom: '10px' }}>
                {selectedText == "ActivityHistory" ?
                  <>
                    <span>State Fee:</span>
                    <span>${"0.00"}</span>
                  </>
                  : <>
                    <span>State Fee:</span>
                    <span>${stateFee.toFixed(2)}</span>
                  </>}
              </div>

              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                width: '100%',
                fontWeight: 'bold',
                borderTop: '1px solid #ccc',
                paddingTop: '10px',
                marginBottom: '20px'
              }}>
                <span>Total:</span>
                {selectedText == "ActivityHistory" ?
                  <>
                    <span>${"4"}</span>
                  </>
                  : <span>${apiCost}</span>
                }
              </div>

            </div>

            <div className="row justify-content-center mt-4">
              <div className="col-auto">
                <AtkButton label="Cancel" onClick={onHidePopupClicked} className="pf-primary-btn w-auto" />
              </div>
              <div className="col-auto">
                <AtkButton label="Ok"
                  onClick={() => {
                    onOkClick();
                  }} className="pf-primary-btn w-auto" />
              </div>
            </div>
          </Dialog>

          <Dialog
            header={
              <div className="d-flex justify-content-between align-items-center w-100">
                <span className="text-16">Upload a File</span>
              </div>
            }
            visible={showDrivingLicenseScanDialog}
            onHide={onHideDrivingLicenseScanDialogClicked}
            draggable={false}
            className="mvr-driving-scan-dialogBox"
          >
            <div className="row">
              <div className="col-12 d-flex justify-content-end">
                <div className="balance-span">
                  <span><small className="d-block w-auto text-danger mt-0">
                    25 cent will be charged per usage
                  </small></span>
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-center align-items-center"
              onDrop={(e) => {
                onDropHandler(e);
              }}
              onDragOver={(e) => {
                e.preventDefault();
              }}>
              <div className="row choose-file-box mt-2">
                {uploadFile.length > 0 ? (
                  <div className="col-12 mt-2">
                    {uploadFile.map((file: any, index: any) => (
                      <div className="mvr-scan-pdf-icon">
                        <div className="scan-file-name">
                          <div className="preview-icon">
                            <img src={PreviewIcon} />
                          </div>
                          <div>
                            <div title={fileNameTitle}>{fileNameTitle}</div>
                            <div>
                              {(parseInt(file.size) / 1000).toFixed(0)}
                              KB
                            </div>
                          </div>
                        </div>
                        <div
                          onClick={() => removeFileFromList()}
                          className="show-cursor"
                        >
                          <img src={RemoveIcon} title="Remove file" />
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <>
                    <div className="row" style={{ textAlign: "center" }}>
                      <div className="col-12">
                        <img src={PfdIcon} alt="" width="70" />
                        <img src={PlusSign} alt="" width="70" />
                        <img src={ImageIcon} alt="" width="70" />
                      </div>

                      <div className="col-12 mt-4">
                        <div className="col-12">
                          <span className="drag-and-drop">
                            Drag & Drop file here
                          </span>
                        </div>
                        <div className="col-12 my-2">
                          <span
                            style={{
                              color: "black",
                              fontSize: "large",
                            }}
                          >
                            or
                          </span>
                        </div>
                        <label className="mb-0 show-cursor">
                          <span className="browse">
                            Browse PDF/JPG/JPEG
                          </span>
                          <input
                            type="file"
                            name="filefield"
                            accept="image/*"
                            id="bulkFileUploader"
                            style={{
                              visibility: "hidden",
                              display: "none",
                            }}
                            onChange={(e) => {
                              onFileSelectHandler(e.target.files);
                            }}
                          />
                        </label>
                      </div>
                    </div>
                  </>
                )}
                <div className="col-12 text-center">
                  {uploadFile.length > 0 && (
                    <div
                      className="d-flex justify-content-center"
                      style={{ width: "100%", padding: "20px" }}
                    >
                      {loading == false ? (
                        <>
                          <AtkButtonIconBefore
                            label="Upload"
                            className="pf-secondary-btn"
                            onClick={() => {
                              createUploadRequest();
                            }}
                            title="Upload file"
                          />
                        </>
                      ) : (
                        <div className="d-flex justify-content-center align-items-center p-2">
                          <AtkLoader></AtkLoader>
                        </div>
                      )}
                    </div>
                  )}
                  {errorMessage.length > 0 ? (
                    <div
                      className="d-flex justify-content-center Acord25-upload-file-error"
                      style={{ width: "100%", padding: "20px 20px 0px" }}
                    >
                      <AtkMessage
                        appearance="error"
                        messageText={errorMessage}
                      />
                    </div>
                  ) : null}
                </div>
              </div>
            </div>

          </Dialog>

        </div>
      </div>


      <div
        className={`row mt-3 mx-auto text-12 ${showSuccessMessage ? "justify-content-center align-items-center" : ""
          }`}
        style={showSuccessMessage ? { minHeight: "50vh" } : {}}
      >
        {showSuccessMessage == true ? (
          <>
            <div className="col-4"></div>
            <div className="col-4">
              <SectionMessage appearance="success">
                <p className="text-14">
                  We are processing your data. Please check the{" "}
                  <b
                    className="show-cursor"
                    style={{ color: "#2dabc1" }}
                    onClick={onHistoryClick}
                  >
                    History
                  </b>{" "}
                  tab to the status of your request.
                </p>
              </SectionMessage>
            </div>
            <div className="col-4"></div>
          </>
        ) : (
          <>

            <div className={`form-group col-lg-4 col-md-4 col-sm-12 mb-2${licenseStateError.length > 0 ? " validation-div" : ""
              }`}>
              <label>License State</label>
              <span className="text-danger"> *</span>
              <Dropdown
                type="text"
                id="text"
                className="mvr-dropdown input-field"
                value={licenseState}
                placeholder="Select state"
                onChange={(e: any) => licenseStateDropdownClicked(e)}
                options={Allstate}
              />
              {licenseStateError && (
                <span className="text-danger">{licenseStateError}</span>
              )}
            </div>
            {selectedText == "ActivityHistory" ?

              <div className="form-group col-lg-4 col-md-4 col-sm-12 mb-2">
                <label>From Date</label>
                <AtkTextField
                  type="date"
                  id="datepicker"
                  value={moment(searchStartDate).format("YYYY-MM-DD")}
                  isDisabled={true}
                  onChange={(e: any) => {
                    onChangeSearchStartDate(e.target.value);
                  }}
                />
              </div>

              :
              <div className={`form-group col-lg-4 col-md-4 col-sm-12 mb-2${selectYearErrorMessage.length > 0 ? " validation-div" : ""
                }`}>
                <label>Select Year</label>
                <span className="text-danger"> *</span>
                <Dropdown
                  type="text"
                  id="text"
                  className="mvr-dropdown input-field"
                  value={selectedSubType}
                  placeholder="Select year"
                  onChange={(e: any) => {
                    yearDropDownClick(e);
                    const selectedFee = fessList.find(
                      (fee) =>
                        fee.state === Allstate.find((state) => state.value === licenseState)?.label &&
                        fee.record_type === e.target.value
                    );
                    if (selectedFee) {
                      setApiCost(selectedFee.cost + 3); // Adding service fee
                      setStateFee(selectedFee.cost);
                    }
                  }}
                  options={fessList
                    .filter((fee) => fee.state === Allstate.find((state) => state.value === licenseState)?.label)
                    .map((fee) => ({ label: fee.record_type, value: fee.record_type }))}
                />
                {selectYearErrorMessage && (
                  <span className="text-danger">{selectYearErrorMessage}</span>
                )}
              </div>

            }

            <div
              className={`form-group col-lg-4 col-md-4 col-sm-12 mb-2${licenseNumberError.length > 0 ? " validation-div" : ""
                }`}
            >
              <label>License Number</label>
              <span className="text-danger"> *</span>
              <AtkTextField
                className="input-field"
                type="text"
                id="text"
                value={licenseNumber}
                onChange={(e) => {
                  onChangeLicenseNumber(e.target.value);
                }}
                placeholder="Enter license number"
              />
              {licenseNumberError && (
                <span className="text-danger">{licenseNumberError}</span>
              )}
            </div>

            <div
              className={`form-group col-lg-4 col-md-4 col-sm-12 mb-2${firstNameError.length > 0 ? " validation-div" : ""
                }`}
            >
              <label>First Name</label>
              <span className="text-danger"> *</span>
              <AtkTextField
                className="input-field"
                type="text"
                id="firstName"
                value={firstName}
                onChange={(e) => {
                  onChangeFirstName(e.target.value);
                }}
                placeholder="Enter first name"
              />
              {firstNameError && (
                <span className="text-danger">{firstNameError}</span>
              )}
            </div>

            <div className="form-group col-lg-4 col-md-4 col-sm-12 mb-2">
              <label>Middle Name</label>
              <AtkTextField
                className="input-field"
                type="text"
                id="middleName"
                value={middleName}
                onChange={(e) => {
                  onChangeMiddleName(e.target.value);
                }}
                placeholder="Enter middle name"
              />
            </div>

            <div
              className={`form-group col-lg-4 col-md-4 col-sm-12 mb-2${lastNameError.length > 0 ? " validation-div" : ""
                }`}
            >
              <label>Last Name</label>
              <span className="text-danger"> *</span>
              <AtkTextField
                className="input-field"
                type="text"
                id="lastName"
                value={lastName}
                onChange={(e) => {
                  onChangeLastName(e.target.value);
                }}
                placeholder="Enter last name"
              />
              {lastNameError && (
                <span className="text-danger">{lastNameError}</span>
              )}
            </div>

            <div
              className={`form-group col-lg-4 col-md-4 col-sm-12 mb-2${birthDateError.length > 0 ? " validation-div" : ""
                }`}
            >
              <label>Birth Date</label>
              <span className="text-danger"> *</span>
              <AtkTextField
                type="date"
                id="datepicker"
                value={moment(birthDate).format("YYYY-MM-DD")}
                onChange={(e: any) => {
                  onChangeBirthDate(e.target.value);
                }}
              />
              {birthDateError && (
                <span className="text-danger">{birthDateError}</span>
              )}
            </div>

            <div className="form-group col-lg-4 col-md-4 col-sm-12 mb-2">
              <label>Address</label>
              <AtkTextField
                className="input-field"
                type="text"
                id="address"
                value={address}
                onChange={(e) => {
                  onChangeAddress(e.target.value);
                }}
                placeholder="Enter address"
              />
            </div>

            <div className="form-group col-lg-4 col-md-4 col-sm-12 mb-2">
              <label>City</label>
              <AtkTextField
                className="input-field"
                type="text"
                id="city"
                value={city}
                onChange={(e) => {
                  onChangeCity(e.target.value);
                }}
                placeholder="Enter city"
              />
            </div>

            <div className="form-group col-lg-4 col-md-4 col-sm-12 mb-2">
              <label>State</label>
              <Dropdown
                type="text"
                id="text"
                className="mvr-dropdown input-field"
                value={state}
                placeholder="Select state"
                onChange={(e: any) => stateDropdownClicked(e)}
                options={Allstate}
              />
            </div>

            <div className="form-group col-lg-4 col-md-4 col-sm-12 mb-2">
              <label>Zip code</label>
              <AtkTextField
                className="input-field"
                type="text"
                id="zipcode"
                value={zipcode}
                onChange={(e) => {
                  onChangeZipcode(e.target.value);
                }}
                placeholder="Enter zip code"
              />
            </div>
            <div className="col-12 text-end ">
              {onSubmitLoading ? (
                <AtkLoader />
              ) : (
                <AtkButtonIconBefore
                  label="Submit"
                  onClick={onSubmitClick}
                  className="pf-secondary-btn"
                />
              )}
            </div>
          </>
        )}
      </div>
    </>
  );
}